import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import Loading from '../../pages/Loading'
import Error from '../../pages/errors/Error'
import {fetchRequiredCourse} from '../../../actions/course'
import {fetchDefaultCourse} from '../../../actions/courses'

const mapStateToProps = ({courses: {isFetchingCourses, isFetchingDefaultCourse, selectedCourseCode}, course: {isFetchingCourse, selectedCourse}, currentUser}) => {
  return {
    loading: isFetchingCourses || isFetchingDefaultCourse || isFetchingCourse,
    courseCode: selectedCourseCode,
    courseNotFound: !selectedCourseCode && !selectedCourse,
    userRole: currentUser.data['role']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchRequiredCourse: courseId => {
      dispatch(fetchRequiredCourse(courseId))
    },
    fetchDefaultCourse: courseId => {
      dispatch(fetchDefaultCourse(courseId))
    },
  }
}

class LoadActiveCourse extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      isNotEmployee: !(this.props.userRole === 'EDITOR' || this.props.userRole === 'REVIEWER'),
    }
  }

  componentDidMount () {
    if (this.state.isNotEmployee) {
      this.props.fetchDefaultCourse(this.props.courseCode)
    }
  }

  render () {
    if (this.props.loading && this.state.isNotEmployee) {
      return <Loading/>
    }

    if (this.props.courseNotFound && this.state.isNotEmployee) {
      return (
        <Error
          title="Unable to access MyVU"
          description="You need to be enrolled in a valid course in order to use MyVU."
        />
      )
    }

    return this.props.children
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoadActiveCourse))
